import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid grid-cols-1 place-items-center mt-52 m-4"
}
const _hoisted_2 = { class: "bg-white p-4 text-center rounded" }
const _hoisted_3 = { class: "my-4" }
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = { class: "my-4" }
const _hoisted_6 = { class: "text-left" }
const _hoisted_7 = { class: "my-4" }
const _hoisted_8 = { class: "text-left" }
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "%", -1)
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "flex justify-between"
}
const _hoisted_13 = { class: "my-auto font-medium text-base" }
const _hoisted_14 = { class: "my-auto font-medium text-base" }
const _hoisted_15 = { class: "relative w-full" }
const _hoisted_16 = { class: "absolute -top-10 -right-4" }
const _hoisted_17 = { class: "text-center text-xl font-semibold uppercase m-0" }

import { ref, inject, onMounted } from "vue";
import { useStore } from "vuex";
import Navbar from "@/components/tools/Navbar.vue";
import { translate } from "@/utils/tools";
import { AxiosInstance } from "axios";
import { CreateFortuneConfig } from "./types/createFortuneConfig.type";
import fortuneConfigDropDown from "@/components/tools/fortuneConfigDropDown.vue"
import { FortuneWheelConfig } from "./types/fortuneWheelConfig.type";
import DialogComponent from "@/components/doalog/DialogComponent.vue";
import { XCircleIcon } from "@heroicons/vue/solid";


export default /*#__PURE__*/_defineComponent({
  __name: 'fortuneWheelConfig',
  setup(__props) {

const store = useStore();
const axios = inject("$axios") as AxiosInstance;

const configData = ref<FortuneWheelConfig>({
  name: "",
  operator_id: store.state.selectedOperator.operatorId,
  point: 0,
  value: [{ id: 0, possibility: 0 }]
});
const createFortuneConfig = ref<CreateFortuneConfig | null>(null);
const updateDialog = ref({
  open: false,
  message: "",
});
const categories = ref([]);
const selectedSync = ref({
  label: translate("messages.reward.selectCategory"),
  value: "SELECT CATEGORY",
});
const onCreate = ref(true);

const addConfig = () => {
  configData.value.value.push({ id: 0, possibility: 0 });
};

const deleteConfig = (index: number) => {
  configData.value.value.splice(index, 1)
};

const getList = async () => {
  const payload = { type: "FORTUNE_WHEEL" };
  const categoryURL = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/loyalty/api/internal/category/list`;

  const { data: categoryData } = await axios.post(categoryURL, payload);
  const categoryId = categoryData.rows[0].id;

  const rewardURL = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/loyalty/api/internal/reward/list`;
  const { data: rewardData } = await axios.post(rewardURL, { categoryId });

  createFortuneConfig.value = rewardData.rows;
  categories.value = rewardData.rows.map((row: any) => ({ label: row.name, value: row.id }));
};

const onSubmit = async () => {
  let validate = 0
  const createFortuneConfigDtoValue = configData.value.value.map((item) => {
    validate += Number(item.possibility*1000000);
    return {
      id: Number(item.dropdown.value),
      possibility: Number(item.possibility)
    }
  })

  if (validate !== 100000000) {
    return updateDialog.value = {
      open: true,
      message: "Please enter a possibility equal to 100%",
    };
  }

  const fotuneConfigPayload = {
    name: configData.value.name,
    operatorId: configData.value.operator_id,
    point: Number(configData.value.point),
    value: createFortuneConfigDtoValue
  }

  const url = onCreate.value
    ? `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/fortune-configs/create`
    : `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/fortune-configs/update/${configData.value.id}`;

  const { data } = await axios["post"](url, fotuneConfigPayload);

  updateDialog.value = {
    open: true,
    message: data ? "update success" : "update fail",
  };
};

const closeDialog = () => {
  updateDialog.value.open = false;
};

const getConfigData = async () => {
  const data = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/fortune-configs/operator`, {
    operatorId: store.state.selectedOperator.operatorId,
  });
  if (data.data) {
    configData.value = data.data
    configData.value.value = data.data.value.map((row: { name: any; id: any, possibility: number }) => {
      return { id: row.id, dropdown: { label: row.name, value: row.id }, possibility: row.possibility }
    })
  }
  onCreate.value = !data.data;
};

onMounted(async () => {
  await getConfigData();
  await getList();
});

const onFortuneOptionSelected = (e: any) => {
  configData.value.value[e.index].dropdown = e.value
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(Navbar, {
        title: _ctx.$t('messages.loyaltyConfig.fortuneWheelConfig')
      }, null, 8, ["title"]),
      (_unref(store).state.user.permissions.includes('LOYALTY.FORTUNE_CONFIG.GET'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("messages.loyaltyConfig.name")), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "rounded w-full uppercase",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((configData.value.name) = $event))
                }, null, 512), [
                  [_vModelText, configData.value.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("messages.loyaltyConfig.point")), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "rounded w-full",
                  min: "1",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((configData.value.point) = $event))
                }, null, 512), [
                  [_vModelText, configData.value.point]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("messages.loyaltyConfig.reward")), 1),
                (configData.value.value.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(configData.value.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.id,
                        class: "w-full flex items-center space-x-2"
                      }, [
                        _createVNode(fortuneConfigDropDown, {
                          class: "w-full py-1",
                          options: categories.value,
                          modelValue: item.dropdown ? item.dropdown : selectedSync.value,
                          onOnFortuneOptionSelected: onFortuneOptionSelected,
                          index: index
                        }, null, 8, ["options", "modelValue", "index"]),
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          "onUpdate:modelValue": ($event: any) => ((item.possibility) = $event),
                          class: "rounded w-full"
                        }, null, 8, _hoisted_9), [
                          [_vModelText, item.possibility]
                        ]),
                        _hoisted_10,
                        _createElementVNode("button", {
                          class: "uppercase rounded px-2",
                          onClick: ($event: any) => (deleteConfig(index))
                        }, "-", 8, _hoisted_11)
                      ]))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              (_unref(store).state.user.permissions.includes('LOYALTY.FORTUNE_CONFIG.CREATE') || _unref(store).state.user.permissions.includes('LOYALTY.FORTUNE_CONFIG.UPDATE'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("button", {
                      class: "bg-blue-400 px-7 py-2 text-white rounded",
                      onClick: addConfig
                    }, [
                      _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("messages.loyaltyConfig.addReward")), 1)
                    ]),
                    _createElementVNode("button", {
                      class: "bg-blue-400 px-7 py-2 text-white rounded",
                      onClick: onSubmit
                    }, [
                      _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("messages.loyaltyConfig.save")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(DialogComponent, {
      isOpen: updateDialog.value.open
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_unref(XCircleIcon), {
              class: "ml-auto w-8 h-8 cursor-pointer",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (updateDialog.value.open = false))
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_17, _toDisplayString(updateDialog.value.message), 1)
      ]),
      _: 1
    }, 8, ["isOpen"])
  ], 64))
}
}

})